import { useQuery } from '@tanstack/react-query';
import { QueryKey } from '@shared/config';
import { aiConstantsApi } from '../../AIConstantsApi';

export const useGetAIConstant = (id: number) => {
  return useQuery({
    queryKey: [QueryKey.GET_AI_CONSTANT, id],
    queryFn: () => aiConstantsApi.getAiConstant(id),
  });
};
